import { render, staticRenderFns } from "./ProcedureDetails.vue?vue&type=template&id=34d7305e&"
import script from "./ProcedureDetails.vue?vue&type=script&lang=js&"
export * from "./ProcedureDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports